import { render, staticRenderFns } from "./GrandKitchenSets.vue?vue&type=template&id=2a9b3a44&scoped=true&"
import script from "./GrandKitchenSets.vue?vue&type=script&lang=js&"
export * from "./GrandKitchenSets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9b3a44",
  null
  
)

export default component.exports